'use strict';

var ElementTools = require('./core/ElementTools.js');
var AFM = require('./animate/FrameManager.js');
var Ease = require('./animate/Ease.js');
var limitNumber = require('./limitNumber.js');
var calcDistance = require('./calcDistance.js');
var log = require('loglevel');
var autosize = require('autosize'); // http://www.jacklmoore.com/autosize/

var IS_WAITING_CLASS_NAME = 'isWaiting';

/**
 * @class
 */
var Forms = {};

/**
 * @public
 */
Forms.init = function() {
	// File attachment fields
	Forms._setupFileInputs();

	// Setup fields (focus, and has value)
	Forms._setupFields();

	// Setup textarea resize
	Forms._setupTextareaAutosize();

	// TODO Listen for an event(s) that indicate page load or ajax complete. Right now we are just calling it once...
	Forms.scrollToFirstMessage();

	var findFormForDetail = function(detail, $default) {
		if (detail.source !== undefined) {
			if (detail.source.form !== undefined) {
				return document.getElementById(detail.source.form.id);
			} else if (detail.source.nodeName.toUpperCase() === 'A') { // JSF h:commandLink and equivalent tags
				for (var parent = detail.source.parentElement; parent !== null; parent = parent.parentElement) {
					if (parent.nodeName.toUpperCase() === 'FORM') {
						return document.getElementById(parent.id);
					}
				}
			}
		}
		return $default;
	};

	document.addEventListener('jsfAjaxEvent', function(event) {
		var detail = event.detail;
		if (detail !== undefined) {
			if (detail.fireType === 'always') {
				// Release form
				Forms.unpauseForm(findFormForDetail(detail, undefined));
				Forms._setupFileInputs();
			} else if (detail.fireType === 'begin') {
				if (document.querySelector('form.' + IS_WAITING_CLASS_NAME) !== null) {
					// We are waiting on a form. Do not do anything.
					event.preventDefault();
					return false;
				}
				var form = findFormForDetail(detail, undefined);
				if (form !== undefined) {
					Forms.pauseForm(form);
				} else {
					// Pause all
					for (var i = 0; i < document.forms.length; i++) {
						Forms.pauseForm(document.forms[i]);
					}
				}
			}
		}
	});

	// Watch for form submissions
	document.addEventListener('submit', Forms._onSubmit.bind(this, 'standard'), false);
};


/**
 * @private
 */
Forms._setupTextareaAutosize = function() {
	var onBlur = function(textarea, event) {
		if (event.target === textarea && textarea.value.trim().length === 0) {
			autosize.update(textarea);
		}
	};
	var textareas = document.querySelectorAll('textarea');

	for (var x=0; x < textareas.length; x++) {
		var textarea = textareas[x];
		autosize(textarea);
		var onBlur_bound = onBlur.bind(this, textarea);
		textarea.addEventListener('blur', onBlur_bound);
		textarea.addEventListener('transitionend', onBlur_bound);
	}
}


/**
 * @private
 */
Forms._setupFields = function() {
	var onMouseEnter = function(area, field, event) { area.classList.add('hasHover'); };
	var onMouseLeave = function(area, field, event) { area.classList.remove('hasHover'); };
	var onFocus	= function(area, field, event) { area.classList.add('hasFocus'); };
	var onBlur	= function(area, field, event) { area.classList.remove('hasFocus'); };
	var onChange = function(area, field, event){
		if (field.value.trim().length !== 0) {
			area.classList.add('hasValue');
		} else {
			area.classList.remove('hasValue');
		}
	};

	var areas = document.querySelectorAll('.fieldArea');
	for (var x=0; x < areas.length; x++) {
		var area = areas[x];
		var fields = area.querySelectorAll('input, textarea, select');
		for (var i=0; i < fields.length; i++) {
			var field = fields[i];
			field.addEventListener('mouseenter', onMouseEnter.bind(this, area, field));
			field.addEventListener('mouseleave', onMouseLeave.bind(this, area, field));
			field.addEventListener('focus', onFocus.bind(this, area, field));
			field.addEventListener('blur', onBlur.bind(this, area, field));
			field.addEventListener('change', onChange.bind(this, area, field));
			onChange(area, field);
		}
	}
}

/**
 * @private
 */
Forms._setupFileInputs = function() {
	var fileInputsAreas = document.querySelectorAll('.htmlInput.uploadFieldArea:not(.setUp)');
	for (var x=0; x < fileInputsAreas.length; x++) {
		var area = fileInputsAreas[x],
			input = area.querySelector('input'),
			label = area.querySelector('label'),
			labelVal = label.innerHTML;

		area.classList.add('setUp');
		input.addEventListener('change', function(e) {
			var fileName = '';
			if (this.files && this.files.length > 1) {
				fileName = this.files.length + ' files selected';
			} else {
				fileName = e.target.value.split('\\').pop();
			}

			if (fileName) {
				label.innerHTML = fileName;
			} else {
				label.innerHTML = labelVal;
			}
		});
	}
}


/**
 * @private
 */
Forms._onSubmit = function(eventType, data) {
	// Find form submitted
	var formElem = null;
	if (eventType === 'a4j' && data.request !== undefined && data.request.form !== undefined) {
		formElem = data.request.form;
	} else if (data.target !== undefined) {
		formElem = data.target;
	}
	
	// TODO Is this too simplistic? Could cause issues in more dynamic situations where there are more submision options for a form, right? What do we really want to do? Maybe not stop form submissions but someobdy simply double clicking a form's submit?
	// Prevent form submissions or additional ajax requests for this form if there is an active submission
	// Pause the submitted form
	if (formElem !== null) {
		if (Forms.isFormPaused(formElem)) {
			if (data.preventDefault !== undefined) {
				data.preventDefault();
			} else if (eventType === 'a4j' && data.request !== undefined && data.request.abort !== undefined) {
				data.request.abort();
			}
		} else {
			Forms.pauseForm(formElem);
		}
	}
}

/**
 * @private
 */
Forms._onSubmitComplete = function(eventType, data) {
	if (eventType === 'a4j' && data.request !== undefined && data.request.form !== undefined) {
		Forms.unpauseForm(data.request.form);
	}
}

/**
 * @private
 */
Forms._onSubmitError = function(eventType, data) {
	log.error('Form submission error', data);
	if (eventType === 'a4j' && data.request !== undefined && data.request.form !== undefined) {
		Forms.unpauseForm(data.request.form);
	}
}


/**
 * @public
 */
Forms.pauseForm = function(formElem) {
	if (formElem !== undefined && formElem !== null) {
		formElem.classList.add(IS_WAITING_CLASS_NAME);
	}
};
/**
 * @public
 */
Forms.unpauseForm = function(formElem) {
	if (formElem !== undefined && formElem !== null) {
		formElem.classList.remove(IS_WAITING_CLASS_NAME);
	}
};

/**
 * @public
 */
Forms.isFormPaused = function(formElem) {
	return formElem !== undefined && formElem !== null && formElem.classList.contains(IS_WAITING_CLASS_NAME);
};


/**
 * @public
 */
Forms.scrollToFirstMessage = function() {
	// Find first '.messages' or '.message'
	var scrollToElem,
		firstMessage = document.querySelector('.messages'),
		containerMatchQuery = 'form';
	
	if (firstMessage === null) {
		firstMessage = document.querySelector('.message');
		containerMatchQuery = '.fieldArea';
	}
	
	if (firstMessage === null) {
		firstMessage = document.querySelector('.formSection__outcomeMessage');
		containerMatchQuery = 'div';
	}

	
	if (firstMessage !== null) {
		// Find the containing 'form' or '.fieldArea', if there is one.
		scrollToElem = firstMessage;
		var curElem = firstMessage
		while(curElem = curElem.parentNode) {
			if (curElem.matches !== undefined) {
				break;
			}
			if (curElem.matches(containerMatchQuery)) {
				scrollToElem = curElem
				break;
			}
		}
		
		// Calc and record animation data
		var offset = ElementTools.getOffsetSum(scrollToElem),
			originX = window.scrollX || window.pageXOffset,
			originY = window.scrollY || window.pageYOffset;
		
			
		// TODO If the far side of the x or y of the container is within viewport, don't scroll along that axis.
		var destX = offset.left,
			destY = offset.top;
		
		var startTime = performance.now(),
			duration = limitNumber(
				Math.abs(calcDistance(originX, originY, destX, destY)) * 2,
				250, 1500
			);
		
		Forms._scrollAnim = {
			start : {
				x : originX,
				y : originY,
				time : startTime
			},
			dest : {
				x : destX,
				y : destY,
				time : startTime + duration
			},
			delta : {
				x : destX - originX,
				y : destY - originY,
				time : duration
			}
		};
		
		AFM.on('write', Forms._scrollTick);
	}
}


/**
 * @private
 */
Forms._scrollTick = function(event, data) {
	if (data.timestamp < Forms._scrollAnim.dest.time) {
		var p = (data.timestamp - Forms._scrollAnim.start.time) / Forms._scrollAnim.delta.time;
		p = Ease.outCubic(limitNumber(p, 0, 1));
		
		var x = Forms._scrollAnim.start.x + (Forms._scrollAnim.delta.x * p),
			y = Forms._scrollAnim.start.y + (Forms._scrollAnim.delta.y * p);
		window.scroll(x, y);
	} else {
		window.scroll(Forms._scrollAnim.dest.x, Forms._scrollAnim.dest.y);
		Forms._scrollAnim = null;
		AFM.off('write', Forms._scrollTick);
	}
}


module.exports = Forms;

